import { Heading3Props } from "./types"
import React from "react"
import { HeadingCore } from "./core"

const Heading3: React.FC<Heading3Props> = (props) => {
  return <HeadingCore {...props} fontSize={"lg"} />
}

export default Heading3
